export default __webpack_public_path__ + "static/media/board.dcde2004.svg";